import { apiClient } from '_app'
import { ApiResponse, DamagePhoto1Dto, DamagePhoto2Dto, DamagePhoto3Dto, VehicleDamageDto } from 'dtos'
import { DamageDto } from 'dtos/damageDto'
import { DamageParameters } from 'parameters/damageParameters'
import { URIQuery } from 'utils'

export const getDamages = (parameters: DamageParameters) =>
  apiClient.get<ApiResponse<VehicleDamageDto[]>>(`/api/damage` + URIQuery({ ...parameters })).then(response => response.data)

export const getDamage = (vehicleGuid: string) =>
  apiClient.get<ApiResponse<VehicleDamageDto>>(`/api/damage/${encodeURIComponent(vehicleGuid)}`).then(response => response.data)

export const createDamage = (vehicleGuid: string, values: VehicleDamageDto) => {
  const data = new FormData()

  if (values.vehicleDamageGuid) {
    data.append('vehicleDamageGuid', values.vehicleDamageGuid)
  }
  if (values.vehicleGuid) {
    data.append('vehicleGuid', values.vehicleGuid)
  }
  if (values.vehicleId) {
    data.append('vehicleId', values.vehicleId)
  }
  if (values.vehicleDamageId) {
    data.append('vehicleDamageId', values.vehicleDamageId)
  }
  if (values.vin) {
    data.append('vin', values.vin)
  }
  if (values.make) {
    data.append('make', values.make)
  }
  if (values.model) {
    data.append('model', values.model)
  }
  if (values.year) {
    data.append('year', values.year)
  }
  if (values.importerStockNumber) {
    data.append('importerStockNumber', values.importerStockNumber)
  }
  if (values.initialDamageDate) {
    data.append('initialDamageDate', values.initialDamageDate)
  }
  if (values.damageDescription) {
    data.append('damageDescription', values.damageDescription)
  }
  if (values.damageStatus) {
    data.append('damageStatus', values.damageStatus)
  }
  // if (values.damagePhoto1FileName) {
  //   data.append('damagePhoto1FileName', values.damagePhoto1FileName)
  // }
  if (values.damagePhoto1File) {
    data.append('damagePhoto1File', values.damagePhoto1File)
  }
  // if (values.damagePhoto2FileName) {
  //   data.append('damagePhoto2FileName', values.damagePhoto2FileName)
  // }
  if (values.damagePhoto2File) {
    data.append('damagePhoto2File', values.damagePhoto2File)
  }
  // if (values.damagePhoto3FileName) {
  //   data.append('damagePhoto3FileName', values.damagePhoto3FileName)
  // }
  if (values.damagePhoto3File) {
    data.append('damagePhoto3File', values.damagePhoto3File)
  }
  // if (values.importBranch) {
  //   data.append('importBranch', values.importBranch)
  // }
  // if (values.exporterCompany) {
  //   data.append('exporterCompany', values.exporterCompany)
  // }
  // if (values.buyerCompany) {
  //   data.append('buyerCompany', values.buyerCompany)
  // }
  // if (values.createdDateTime) {
  //   data.append('createdDateTime', values.createdDateTime)
  // }
  // if (values.createdBy) {
  //   data.append('createdBy', values.createdBy)
  // }
  // if (values.updatedDateTime) {
  //   data.append('updatedDateTime', values.updatedDateTime)
  // }
  // if (values.updatedBy) {
  //   data.append('updatedBy', values.updatedBy)
  // }

  return apiClient<ApiResponse<DamagePhoto1Dto>>({
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: `/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}`
  }).then(response => response.data)
}

export const updateDamage = (vehicleGuid: string, values: DamageDto) =>
  apiClient
    .put<ApiResponse<DamageDto>>(`/api/damage/${encodeURIComponent(vehicleGuid)}`, values)
    .then(response => response.data)

export const getDamageSearchOrScanVehicle = (search: string) =>
  apiClient
    .get<ApiResponse<VehicleDamageDto | undefined>>(
      '/api/damage/add-damage/search-or-scan-vehicle?search=' + encodeURIComponent(search)
    )
    .then(response => response.data)

export const getDamagePhoto1Information = (vehicleGuid: string, fileName: string) =>
  apiClient
    .get<string>(`/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}/damage-photo-1/${encodeURIComponent(fileName)}`)
    .then(response => response.data)

export const updateDamagePhoto1Information = (vehicleGuid: string, values: DamagePhoto1Dto) => {
  const payload = new FormData()
  if (values.damagePhoto1File) {
    payload.append('damagePhoto1File', values.damagePhoto1File)
  }

  return apiClient<ApiResponse<DamagePhoto1Dto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}/damage-photo-1`
  }).then(response => response.data)
}

export const deleteDamagePhoto1 = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<DamagePhoto1Dto>>(`/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}/damage-photo-1/}`)
    .then(response => response.data)

export const getDamagePhoto1PhotoBase64 = (vehicleGuid: string, fileName: string) =>
  apiClient
    .get<string>(`/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}/damage-photo-1/${encodeURIComponent(fileName)}`)
    .then(response => response.data)

export const getDamagePhoto2Information = (vehicleGuid: string, fileName: string) =>
  apiClient
    .get<string>(`/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}/damage-photo-2/${encodeURIComponent(fileName)}`)
    .then(response => response.data)

export const updateDamagePhoto2Information = (vehicleGuid: string, values: DamagePhoto2Dto) => {
  const payload = new FormData()
  if (values.damagePhoto2File) {
    payload.append('damagePhoto2File', values.damagePhoto2File)
  }

  return apiClient<ApiResponse<DamagePhoto2Dto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}/damage-photo-2`
  }).then(response => response.data)
}

export const deleteDamagePhoto2 = (vehicleGuid: string, vehicleDamageGuid: string) =>
  apiClient
    .delete<ApiResponse<DamagePhoto2Dto>>(
      `/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}/damage-photo-2/${encodeURIComponent(vehicleDamageGuid)}`
    )
    .then(response => response.data)

export const getDamagePhoto2PhotoBase64 = (vehicleGuid: string, fileName: string) =>
  apiClient
    .get<string>(`/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}/damage-photo-2/${encodeURIComponent(fileName)}`)
    .then(response => response.data)

export const getDamagePhoto3Information = (vehicleGuid: string, fileName: string) =>
  apiClient
    .get<string>(`/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}/damage-photo-3/${encodeURIComponent(fileName)}`)
    .then(response => response.data)

export const updateDamagePhoto3Information = (vehicleGuid: string, values: DamagePhoto3Dto) => {
  const payload = new FormData()
  if (values.damagePhoto3File) {
    payload.append('damagePhoto3File', values.damagePhoto3File)
  }

  return apiClient<ApiResponse<DamagePhoto3Dto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}/damage-photo-3`
  }).then(response => response.data)
}

export const deleteDamagePhoto3 = (vehicleGuid: string, vehicleDamageGuid: string) =>
  apiClient
    .delete<ApiResponse<DamagePhoto3Dto>>(
      `/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}/damage-photo-3/${encodeURIComponent(vehicleDamageGuid)}`
    )
    .then(response => response.data)

export const getDamagePhoto3PhotoBase64 = (vehicleGuid: string, fileName: string) =>
  apiClient
    .get<string>(`/api/damage/add-damage/${encodeURIComponent(vehicleGuid)}/damage-photo-3/${encodeURIComponent(fileName)}`)
    .then(response => response.data)
